export const OTP_RESEND_INTERVAL_S = 30; // In Seconds
export const FRONTEND_DATE_FORMAT = "DD-MM-YYYY";
export const BACKEND_DATE_FORMAT = "YYYY-MM-DD";

export enum PAGE_URLS {
  FORGOT_PASSWORD = "/forgot-password",
  RESET_PASSWORD = "/reset-password",
  LOGIN = "/login",
  NOT_FOUND = "/not-found",
  SESSION_EXPIRED = "/session-expired",
  SETTINGS = "/settings",
  DRAFTS = "/drafts",
  REPORTS = "/reports",
  SELECT_CORPORATE = "/select-corporate",
  ISSUE_CREDITS = "/issue-credits",
  CREDITS_LISTING = "/credits-listing",
  ISSUE_CREDITS_SUCCESS = "/issue-credits/success",
  SAVED_FILES = "/saved-files",
  CREDIT_REPORTS = "/credit-reports",
  USER_MANAGEMENT = "/user-management",
  SEND_REMINDER = "/send-reminder",
  ACCESS_DENIED = "/access-denied",
  ERROR_500 = "/error-500",
  NO_INTERNET = "/no-internet",
}

export enum GET_HELP_LINK {
  EN = "https://support.yougotagift.com/hc/en-us#b2b-support",
}
export const PRIVACY_POLICY_LINK =
  "https://yougotagift.com/shop/privacy-policy/";

export const GIFTING_URL = "https://yougotagift.com/shop/en-in";
export const GROUP_GIFT_URL = "https://app.groupgift.yougotagift.com";
export const HAPPY_YOU_URL = "https://yougotagift.com/shop/en-in/offers";
export const SOLUTIONS_HUB_URL = "https://yougotagift.com/solutions-hub/en";
export const TERMS_OF_USE_LINK = "https://yougotagift.com/shop/terms-of-use/";

export enum FOOTER_ITEM_TYPE {
  ITEM_CODE_OUR_SOCIAL = "ITEM_CODE_OUR_SOCIAL",
  ITEM_CODE_OUR_SERVICES = "ITEM_CODE_OUR_SERVICES",
  ITEM_CODE_SUPPORT = "ITEM_CODE_SUPPORT",
  FB_ITEM_CODE = "FB_ITEM_CODE",
  ITEM_CODE_FOR_DEVELOPERS = "ITEM_CODE_FOR_DEVELOPERS",
}



export enum SETTINGS_TABS {
  PROFILE = "profile",
  CHANGE_PASSWORD = "password",
}
